export default {
    form: {
        product_id: null,
        name: null,
        email: null
    },
    reset_modal: false,
    product: null
};
